import { createStore, action } from 'easy-peasy';
import accountModel from './account-model';
import authModel from './auth-model';
import purchasesModel from './purchases-model';
import newFeaturesModel from './new-features-model';
import frontpageInfo from './frontpageInfo';
import companies from './companies-model';
import helptexts from './helptexts-model';
import pumpsModel from './pumps-model.js';
import poolsModel from './pools-model.js';

export const store = createStore({
  account: accountModel,
  auth: authModel,
  purchases: purchasesModel,
  newFeatures: newFeaturesModel,
  frontpageInfo: frontpageInfo,
  companies: companies,
  helptexts: helptexts,
  pumps: pumpsModel,
  pools: poolsModel,
  tags: {
    getTags: action(() => {
      // Placeholder action - implement when needed
      console.log('tags.getTags called');
    })
  }
});
